import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/metaPixel';
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  size = 'lg',
  fullWidth = false,
  className = ''
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-lg md:text-xl' : 'px-5 py-3 text-base';
  const isCheckout = href === CHECKOUT_URL;
  return <motion.a href={href} onClick={isCheckout ? trackInitiateCheckout : undefined} whileHover={{
    y: -2
  }} whileTap={{
    y: 3
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-sun font-display font-semibold text-ink shadow-cta transition-shadow duration-150 ease-out hover:shadow-ctaHover active:shadow-none focus:outline-none focus-visible:ring-4 focus-visible:ring-teal/30 ${sizing} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-46" data-mp="2oyfc5jlljtic">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden data-id="element-47" data-mp="1dckszua56hqw" />
    </motion.a>;
}